import React, { Dispatch, SetStateAction } from 'react';

import { Box, Divider, Drawer } from '@mui/material';

import { Decision } from '../../../../common/constants/decision';
import { Resource } from '../../../../common/constants/resource';
import DrawerHeader from '../DrawerHeader';
import styles from '../styles.module.scss';
import { WaiveFormData } from './useWaiveForm';
import WaiveForm from './WaiveForm';

const EditWaive = ({
  isOpen,
  setIsOpen,
  isUpdate,
  onSuccess,
  initialFormData,
  onDecisionChanged,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isUpdate: boolean;
  onSuccess: (formData: WaiveFormData) => void;
  initialFormData?: WaiveFormData | null;
  onDecisionChanged?: (decision: Decision) => void;
}) => (
  <Drawer
    open={isOpen}
    anchor="right"
    variant="persistent"
    classes={{ paper: styles.Drawer }}
    transitionDuration={{ enter: 0, exit: 0 }}
  >
    <DrawerHeader
      title={
        isUpdate ? Resource.UPDATE_DECISION_HEADER : Resource.WAIVE_DECISION
      }
      onClose={() => setIsOpen(false)}
    />
    <Divider />
    <Box m={3}>
      <WaiveForm
        onDecisionChanged={onDecisionChanged}
        initialFormData={initialFormData}
        isOpen={isOpen}
        onSuccess={onSuccess}
        isUpdate={isUpdate}
      />
    </Box>
  </Drawer>
);

export default EditWaive;
